export function parseDate(epoch: number): string {
  const date = new Date(epoch);
  return new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' }).format(date);
}
